var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('h1',[_vm._v("Total patients")]),_c('vue-apex-charts',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"type":"bar"}}),_c('mixn',{ref:"mixin"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }